/*
 * Copyright 2024 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import {
  createExtensionBlueprint,
  createExtensionDataRef,
} from '@backstage/frontend-plugin-api';
import { ScaffolderFormDecorator } from '../extensions';

const formDecoratorExtensionDataRef =
  createExtensionDataRef<ScaffolderFormDecorator>().with({
    id: 'scaffolder.form-decorator-loader',
  });

/**
 * @alpha
 * Creates extensions that are Field Extensions for the Scaffolder
 * */
export const FormDecoratorBlueprint = createExtensionBlueprint({
  kind: 'scaffolder-form-decorator',
  attachTo: { id: 'api:scaffolder/form-decorators', input: 'formDecorators' },
  dataRefs: {
    formDecoratorLoader: formDecoratorExtensionDataRef,
  },
  output: [formDecoratorExtensionDataRef],
  *factory(params: { decorator: ScaffolderFormDecorator }) {
    yield formDecoratorExtensionDataRef(params.decorator);
  },
});
